import React from 'react'

type ToggleProps = {
  value: boolean
  onChange: () => void
}

export default function Toggle({ value, onChange }: ToggleProps) {
  return (
    <div
      onClick={onChange}
      className={`relative inline-block w-6 h-3 rounded-full cursor-pointer transition-colors duration-300 max-sm:hidden ${value ? 'bg-black' : 'bg-white'}`}
    >
      <div
        className={`w-2 h-2 rounded-full transition-all duration-300 absolute top-0.5 ${value ? 'bg-white left-[14px]' : 'bg-black left-0.5'}`}
      />
    </div>
  )
}
